import { styled } from '@mui/material/styles';
import { COLOR } from '@src/styles/color';
import { Box } from '@mui/material';
import { MOBILE_BREAKPOINT } from '@src/styles/config';

const StyledSurvey = styled('div')`
  width: 100%;
  display: flex;
  box-sizing: border-box;
  padding: ${(props) => (props?.isMobile ? '24px' : '60px')};
  flex-direction: column;
  flex: 1;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999999;
  height: ${(props) => (props?.height ? `${props?.height}px` : '100vh')};
  background-color: ${COLOR.white};
  overflow-y: scroll;
  padding-bottom: 100px;
  gap: 32px;
  .container-survey {
    width: 100%;
    max-width: 1024px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 32px;
  }
`;

const StyledQuestion = styled('div')`
  gap: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  .container-question {
    gap: 8px;
    .title-question {
      color: ${COLOR.black.default};
      text-align: center;
      font-size: 32px;
      font-weight: 700;
    }
    .title-sub-option {
      color: #1c1c1ea3;
      text-align: center;
      font-size: 16px;
      font-weight: 400;
    }
  }
  .container-answer {
    width: 100%;
    .text-item-answer {
      color: ${COLOR.black.default};
      font-size: 16px;
      font-weight: 500;
    }
  }

  .container-skeleton-survey {
    display: flex;
    width: 257px;
    align-items: center;
    gap: 8px;
    padding: 8px 16px;
    height: 74px;
    border-radius: 8px;
    box-sizing: border-box;
    border: 1px solid #1e164e29;
  }

  .skeleton-survey {
    background: linear-gradient(
      90deg,
      rgba(60, 60, 67, 0.16) 0%,
      rgba(255, 255, 255, 0.16) 100%
    );
  }

  @media only screen and (max-width: 1000px) {
    .container-skeleton-survey {
      width: 100% !important;
    }
  }

  .input-other {
    box-sizing: border-box;
    display: flex;
    justify-content: flex-start;
    flex-direction: row;
    min-width: 257px;
    width: 100%;
    align-items: center;
    gap: 8px;
    min-height: 64px;
    border-radius: 8px;
    padding: 8px 16px;
    background: ${COLOR.white};
    border: 1px solid ${COLOR.secondary['16']};
    color: ${COLOR.darkGray};
    font-size: 16px;
    font-weight: 500;
    margin-top: 16px;
    outline: none;
    &::placeholder {
      color: ${COLOR.label2['48']};
    }

    @media only screen and (max-width: 1000px) {
      width: calc(100% - 8px);
    }

    @media only screen and (max-width: ${MOBILE_BREAKPOINT}) {
      width: 100%;
    }
  }
  @media only screen and (max-width: ${MOBILE_BREAKPOINT}) {
    width: 100%;
    .container-question {
      .title-question {
        font-size: 16px;
      }
      .title-sub-option {
        font-size: 12px;
      }
    }
  }
`;

const StyledQuestionItem = styled(Box)`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  box-sizing: border-box;
  align-items: center;
  gap: 8px;
  min-height: 64px;
  height: 100%;
  border-radius: 8px;
  flex: 1;
  padding: 8px 16px;
  background: ${COLOR.white};
  outline: 1px solid ${COLOR.secondary['16']};
  &:hover {
    cursor: pointer;
    background: ${COLOR.gray};
  }

  @media only screen and (max-width: 1000px) {
    width: 100%;
  }

  ${({ selected }) =>
    selected &&
    `outline: 2px solid ${COLOR.primary};
     background: #FFFCEC;
     &:hover {
      background: #FFFCEC;
      outline: 2px solid ${COLOR.primary}
     }
  `}

  .name {
    color: ${COLOR.black.default};
    font-size: 16px;
    font-weight: 500;
  }

  .container-icon {
    width: fit-content;
    display: flex;
    align-items: center;
    justify-content: center;
    .icon {
      width: 24px;
      height: 32px;
      object-fit: contain;
    }
  }

  .answer-desc {
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    text-align: left;
    color: #1c1c1ea3;
  }
  @media only screen and (max-width: ${MOBILE_BREAKPOINT}) {
    .name {
      font-size: 14px;
    }
  }
`;

const StyledActionsSurvey = styled('div')`
  position: ${(props) => props?.isMobile && 'fixed'};
  bottom: ${(props) => props?.isMobile && '0'};
  width: 100%;
  background-color: ${(props) => props?.isMobile && '#ffffff'};
  height: ${(props) => props?.isMobile && '73px'};
  padding: ${(props) => props?.isMobile && '8px 16px'};
  display: flex;
  justify-content: ${(props) => (props?.isMobile ? 'center' : 'space-between')};
  align-items: center;

  .skip-action {
    color: ${COLOR.darkBlue};
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    letter-spacing: -0.4px;
  }

  .actions-btn {
    display: flex;
    align-items: center;
    gap: 16px;
    width: ${(props) => props?.isMobile && '90%'};
    .prev-button {
      border: 1px solid #1e164e52;
      padding: 12px;
      border-radius: 12px;
      color: ${COLOR.indigo.default};
      width: 156px;
      height: 48px;
      font-weight: 700;
      font-size: 16px;
      text-transform: none;
      line-height: 24px;
      ${({ hasButtonPreviousDisabled }) =>
        hasButtonPreviousDisabled && `opacity: 0.4;`}
    }

    .next-button {
      padding: 12px;
      border-radius: 12px;
      color: ${COLOR.darkBlue};
      width: ${(props) => (props?.isMobile ? '100%' : '156px')};
      height: 48px;
      font-weight: 700;
      font-size: 16px;
      text-transform: none;
      line-height: 24px;
      background-color: ${COLOR.primary};
      ${({ hasButtonNextDisabled }) => hasButtonNextDisabled && `opacity: 0.4;`}
    }
  }
`;

const StyledStepProgessBar = styled('div')`
  display: flex;
  align-items: center;
  justify-content: ${(props) => (props?.isMobile ? 'space-between' : 'center')};
  width: 100%;
  margin-top: 30px;
  .skip-action {
    color: #1c1c1e !important;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    letter-spacing: -0.4px;
  }
  .container-step {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: ${(props) => (props?.isMobile ? '8px' : '16px')};
    .step {
      width: ${(props) => (props?.isMobile ? '70px' : '80px')};
      border-radius: 480px;
      height: 6px;
      background-color: ${COLOR.secondary['80']};
    }
    .active-step {
      background-color: ${COLOR.darkBlue};
    }
  }
  .disabled-prev-btn {
    color: #1e164ea3;
    opacity: 0.6;
  }
`;

export {
  StyledStepProgessBar,
  StyledActionsSurvey,
  StyledSurvey,
  StyledQuestion,
  StyledQuestionItem,
};
